module.exports = __webpack_public_path__ + "assets/img/eleven8.893bde47.png";